<template>
  <div class="workflow-edit-stop">
    <div class="map-wrapper">
      <div :id="mapID" />
    </div>
    <div style="margin-top: 10px">
      <span
        class="button is-success is-medium is-fullwidth is-rounded"
        @click="emit"
      >Set Stop Location</span>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import L from "leaflet";
import "leaflet.awesome-markers";
import { mapState } from "vuex";

export default {
  name: "WorkflowEditStop",
  computed: mapState(["googleCoords"]),
  watch: {
    googleCoords: function(newVal, oldVal) {
      this.console("googleCoords changed, new: ", newVal, " | old: ", oldVal);
      this.updateMarkerLocation();
    }
  },
  data() {
    return {
      mapID: "edit-stop-map",
      map: undefined,
      marker: undefined,
      name: null
    };
  },
  mounted() {
    L.AwesomeMarkers.Icon.prototype.options.prefix = "fa";
    this.initMap();
    EventBus.$on("EDITING_STOPS", stops => {
      console.log("stops", stops);
      this.drawStops(stops);
      this.$nextTick(() => this.redrawMap()); // trigger redraw on next tick every new stop
    });
  },
  methods: {
    updateMarkerLocation() {
      this.map.panTo(this.googleCoords); // setView, flyTo
      this.marker.setLatLng(this.googleCoords); //this.map.getCenter());
    },
    redrawMap() {
      this.map.invalidateSize();
    },
    setStopCoords(coords) {
      this.$store.commit("setStopCoords", coords);
    },
    drawStops(stops) {
      stops.forEach(s => {
        L.circle(s, {
          color: "blue",
          weight: 1,
          opacity: 0.3,
          fillColor: "cyan",
          fillOpacity: 0,
          radius: 3000
        }).addTo(this.map);
      });
    },
    emit() {
      var coords = this.marker.getLatLng();
      var data = {
        name: this.name, // name is not getting passed through yet
        lat: coords.lat,
        lon: coords.lng
      };
      this.$emit("editedStop", data);
    },
    initMap() {
      // var mapboxToken = `pk.eyJ1Ijoibmlja3R1ayIsImEiOiJjanpxZjNyNWMwZ2JtM2xxc2Qzb3pnaXpqIn0.K0REWPkiR2k4QAwCDjUdHw`;
      // var urlMapbox = `https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${mapboxToken}`;
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps
      var bangkokCoords = [13.73114, 100.57529]; // soi 41
      var initialLocation = this.$store.state.googleCoords;
      if (!initialLocation) initialLocation = bangkokCoords;

      this.map = L.map(this.mapID, { attributionControl: false });
      this.map.setView(initialLocation, 17);
      this.map.scrollWheelZoom.disable();
      // this.map.removeControl(this.map.zoomControl);
      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        minZoom: 2,
        maxZoom: 19
      }).addTo(this.map);
      this.map.invalidateSize();

      var icon = L.AwesomeMarkers.icon({
        icon: "fa-crosshairs",
        markerColor: "black",
        iconColor: "cyan",
        extraClasses: "fa-lg"
      });
      this.marker = L.marker(initialLocation, { icon: icon }).addTo(this.map);

      this.marker.on("click", () => this.emit());

      this.map.on("move", () => this.marker.setLatLng(this.map.getCenter()));

      this.map.on("dragend", e => {
        this.console("marker moved", this.marker, e);
        this.setStopCoords(this.map.getCenter());
        this.marker.setLatLng(this.map.getCenter()); // set marker to center
      });
    }
  }
};
</script>

<style scoped>
.map-wrapper {
  position: relative;
  border-radius: 25px;
  border: 1px solid rgba(128, 128, 128, 0.3);
}
#edit-stop-map {
  height: 60vh;
  max-height: none;
  width: 100%;
  border-radius: 25px;
}
</style>